
import React, { Component } from 'react';
import services from '../../../services';
import $ from 'jquery'
import TlkTable from '../../../components/tlelrik/table/tlkTable';

var moment = require('moment')
const dateFormat = "YYYY-MM-DD";
let listdefaultRequest = { Filters: null, "SortBy": "", "IsSortTypeDESC": true, "IsPagination": true, "Page": 1, "PageSize": 100 }
const dateFormat2 = "DD-MM-YYYY HH:mm";

let tablesjson = {
    "SelosPendentes": {
        columnkeyMap: {
           // "entidade": "Entidade",
            "tipoSelo": "Tipo Selo",
            "produto": "Tipo Produto",
            "quantidade": "Quantidade",
            "capacidade": "Capacidade Garrafas",
            "estado": "Estado",
            "dataSubmissao": "Data",
            // "tipoPedido": "Tipo Pedido",
            // "quantidade": "Quantidade",
            // "estado": "Estado",
            // "dataSubmissao": "Data de submissão"
        },
        actionbuttons: { 
            // module: "selos", 
            // menu: "pedidos",
            // submenu: "pending", 
        },// Redirect: "Emitir Fatura",
        listApilink: "Fiscalizacao/GetViewPedidoSelosEtiquetasPendentes",
        requestMethod: "get",
        notAction: false,
        totalPageHeading : "Lista de pedidos selos e etiquetas ",
        // deleteAPILink: "/BusEntidadeEstatuto/Delete/",
        Filters: {
            NIFEntidade:null
        },
        groupfield: []
    },
    "SelosTodosPedidos": {
        columnkeyMap: {
            "numeroPedido": "Nº Pedido",
            "tipoSelo": "Tipo Selo",
            "produto": "Produto",
            "serie": "Série",
            "intervalo": "Intervalo",
            "quantidade": "Quantidade",
            "capacidade": "Capacidade Garrafas",
            "correlativa": "Nº de Rotulagem",
            "estado": "Estado",
            "dataSubmissao": "Data",
            "dataEntrega": "Data da Última Atualização",
            "grafica" : "Gráfica",
            // "tipoPedido": "Tipo Pedido",
            // "quantidade": "Quantidade",
            // "estado": "Estado",
            // "dataSubmissao": "Data de submissão"
        },
        actionbuttons: {},
        listApilink: "Selos/GetSelosEntidade",
        requestMethod: "get",
        notAction: false,
        totalPageHeading : "Lista de pedidos selos e etiquetas ",
        Filters: {
            NIFEntidade:null
        },
        groupfield: []
    },
    "SelosRequisiçãoPendentes": {
        columnkeyMap: {
            "grafica": "Gráfica",
            "serie" : "Série",
            "intervalo" : "Intervalo", 
            "quantidade": "Quantidade", 
            //"estado": "Estado", 
            "dataSubmissao": "Data Submissão"
           
        },
        actionbuttons: { 

        },
        listApilink: "selos/GetGraficaSelosByEntidade",
        requestMethod: "post",
        notAction: false,
        totalPageHeading : "Lista de requisições de selos ",
        Filters: {
            NIFEntidade:null
        },
        groupfield: []
    },"SelosRastreabilidade": {
        columnkeyMap: {
            //"acidez": "Acidez",
            //"anoProduto" : "Ano",
            
            
            //"corProduto": "Cor",
            //"correlativa": "Correlativa",
            //"dataAposicao": "Data Aposição",
            //"dataEntrega": "Data Entrega",
            "serie": "Série",
            "tipoSelo": "Tipo Selo",
            "produto": "Tipo Produto",
            "capacidade": "Capacidade",
            "grafica": "Gráfica",
            //"graficaNumeroInicial": "Gráfica Nº Inicial",
            //"graficaNumeroFinal": "Gráfica Nº Final",
            "entidade": "Entidade",
            //"entidadeNumeroFinal": "Entidade Nº Final",
            //"entidadeNumeroInicial": "Entidade Nº Inicial",
            //"aposicaoNumeroInicial": "Aposição Nº Inicial",
            //"aposicaoNumeroFinal": "Aposição Nº Final",
            
            //"grauDocura": "Doçura",
            //"madeira": "Madeira",
            //"marca": "Marca",
            //"numeroRegisto" : "Nr Registo",
            //"pais": "País",
            
            //"teorAlcoolico": "TAV",
            



            // "grafica": "Gráfica",
            // "entidade": "Entidade",
            // "tipoSelo": "Tipo de Selo",
            // "serie" : "Série"
           
        },
        actionbuttons: { 

        },
        listApilink: "selos/GetRastreabilidadeSelo",
        requestMethod: "get",
        notAction: false,
        totalPageHeading : "Detalhes do selo ",
        Filters: {
            NIFEntidade:null,
            NumeroSelo: ""
        },
        groupfield: [],
        collepsview: true,
        viewFor: "selosRastreabilidade"
    },
    "AposiçãoDeSelos" :  {
        columnkeyMap: {
            "nCom":"Nº Com",
            "data_de_pedido":"Data",
            "tipo_de_pedido": "Tipo",
            "dataApos":"Data Apos",
            "entidade": "Entidade",
            "nRegisto":"Nr Registo",
            "lote": "Lote",
            "estado": "Estado",
        },
        actionbuttons: { affixingSeals: "Detalhes" },// Redirect: "Emitir Fatura",
        listApilink: "Selos/GetRequisicaoSelosList",
        requestMethod: "post",
        notAction: false,
        totalPageHeading : "Avaliações realizadas a aguardar ",
        modulename: "RotulosOneAvalicao",
        Filters: {
            "nome": null,
            "numero": null,
            // "startDate": "24-01-2019",
            // "endDate": "27-04-2022",
            "estado": null,
            "tipoOperacao": "Aposicao"
          },
        groupfield: []
    }
}


class SelosTables extends Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            linkData: tablesjson[this.props.tableName],
            telkikTable: null,
            popUpForm: null,
            tlkState: null,
            error : null,
            showSearchMsg:false,
            totalcount : 0
        }
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount = () => {
        //console.log("mount")
        //this.defaultState();
    }

    /* Esta função irá chamar automaticamente quando o estado da página mudar  */
    componentDidUpdate = (preProp) => {
        if (preProp.date !== this.props.date || preProp.tableName !== this.props.tableName) {
            //console.log("update",this.props,preProp)
            this.defaultState();
        }
    }


    /* Para obter filtros para a API */
    getAllFilter = () => {
        let Request = { ...listdefaultRequest };
        Request.Filters = this.state.linkData.Filters;
        let appliedFilter = {...this.props.applyedfilter}
        if(appliedFilter){
            if(appliedFilter['start_date'] || appliedFilter['end_date']){
                appliedFilter['startDate'] = this.props.applyedfilter['start_date']
                appliedFilter['endDate'] = this.props.applyedfilter['end_date']
                delete appliedFilter['end_date']
                delete appliedFilter['start_date']
            }
        }
        delete appliedFilter['local'];
        console.log("applied",appliedFilter)
        Request.Filters = { ...Request.Filters, ...appliedFilter }
        Request.NIFEntidade = appliedFilter != null ? appliedFilter.entityIdFilter != null ? appliedFilter.entityIdFilter : "" : ""
        Request.NumeroSelo = $("#KeyDownId").val() ? $("#KeyDownId").val() : "" //"AA0A0-0015001"

        console.log("Request: ", Request)

        return Request;
    }


    /*  Para excluir uma linha da base de dados no servidor */

    handleDelete = async (id) => {
        let link = this.state.linkData.deleteAPILink;
        let res = await services.apiCall.requestApi(link + "/" + id, {}, 'post')
        if (res) {
            this.defaultState();
        }
    }

    /* Carregar estado de página padrão  */

    defaultState = () => {
        let linkData = { ...tablesjson }
        linkData = tablesjson[this.props.tableName];
        this.setState({
            linkData: linkData,
            tlkState: {
                take: 10,
                skip: 0,
                group: [],
                exporting: false,
            }
        }, () => this.getListData())
    }

    /*Para obter dados para a tabela usando apis */

    getListData = async () => {
        try {
            if (!this.state.linkData) return
            let Request = this.getAllFilter();
            if (this.state.linkData.singleEntity) {
                this.setState({
                    totalcount: 0,
                    telkikTable: null,                       
                })
            }
            if (this.state.linkData.singleEntity && (!Request.Filters.entity_id && !Request.Filters.invoice_id)) return
            let method = this.state.linkData.requestMethod;
            let link = this.state.linkData.listApilink;
            let columnkeyMap = this.state.linkData.columnkeyMap;
            let res = await services.apiCall.requestApi(link, Request, method);
            if (res && res.length > 0) {
                //console.log("theeeeeeeeeeeeeeeeeeeeeeeeee", res)
                res.map((_row, index) => {
                    Object.keys(columnkeyMap).map(function (key) {
                        
                        // if (key === "entidade") {
                        //     _row[columnkeyMap[key]] = _row.nome
                        // }
                        if (key === "entidade") {
                            _row[columnkeyMap[key]] = _row.entidade
                        }
                        else if (key === "nCom") {
                            _row[columnkeyMap[key]] = _row.idEntidadeAplicacao
                            // console.log("printed by vaibhav")
                        }
                        else if (key === "quantidade") {
                            _row[columnkeyMap[key]] = services.money.format(_row.quantidade, 0, '', '.') || "0";
                        } 
                        else if(key === 'estado'){
                            _row['Estado'] = _row.estado
                        }
                        else if (key === "n_pedido") {
                            _row[columnkeyMap[key]] = _row.codRegistoSelo
                        }
                        else if (key === "nRegisto") {
                            _row[columnkeyMap[key]] = _row.idEntidadeAplicacao
                        }
                        else if (key === "n_de_selo") {
                            _row[columnkeyMap[key]] = parseInt(_row['nSelos'].trim())
                        }
                        else if (key === "data_de_pedido") {
                            _row[columnkeyMap[key]] = _row.dataCriado ? moment(_row.dataCriado).format(dateFormat) : 'nd'
                        }
                        else if (key === "data_de_decisao") { 
                            _row[columnkeyMap[key]] = _row.dataOperacao ? moment(_row.dataOperacao).format(dateFormat) : 'nd'
                        }
                        else if (key === "tipo_de_pedido") {
                            _row[columnkeyMap[key]] = _row.tipoPedido
                        }
                        else if (key === "tipo_de_selo") {
                            _row[columnkeyMap[key]] = _row.tipoSelo
                        }
                        else if (key === "idEntidadeSolicitante") {
                            _row[columnkeyMap[key]] = _row.idEntidadeSolicitante
                        }
                        else if (key === "lote") {
                            _row[columnkeyMap[key]] = _row.lote
                        }
                        else if (key === "dataApos") {
                            _row[columnkeyMap[key]] = _row.dataModificado ? moment(_row.dataModificado).format(dateFormat) : 'nd'
                        }else if(key === "dataSubmissao"){
                            _row[columnkeyMap[key]] = _row.dataSubmissao
                                ? moment(_row.dataSubmissao).format(
                                    dateFormat2
                                  )
                                : "nd";
                        }else if(key === "dataCriado"){
                            _row[columnkeyMap[key]] = _row.dataCriado
                                ? moment(_row.dataCriado).format(
                                    dateFormat2
                                  )
                                : "nd";
                         }else if(key === "dataAposicao"){
                            _row[columnkeyMap[key]] = _row.dataAposicao
                                ? moment(_row.dataAposicao).format(
                                    dateFormat2
                                  )
                                : "nd";
                         }else if(key === "dataEntrega"){
                            _row[columnkeyMap[key]] = _row.dataEntrega
                                ? moment(_row.dataEntrega).format(
                                    dateFormat2
                                  )
                                : "nd";
                         }
                        else
                            _row[columnkeyMap[key]] = _row[key] || 'nd'
                    })
                });
                //console.log("Akash","1",res);
                window.localStorage.setItem('table_total', res.length);
                this.setState({
                    data: res,
                    filterData: res,
                    showSearchMsg:false,
                    totalcount: window.localStorage.getItem('table_total'),
                }, () =>{
                    //console.log("Akash","2");
                    this.createTabel()
                });
            }else{
                this.setState({
                    showSearchMsg : true,
                    totalcount : 0,
                    telkikTable : null
                })
            }
        } catch (error) {
            this.setState({error})
        }
    }

    /* Para carregar o componente da tabela e definir todas as colunas  */

    createTabel = () => {
        // console.log("Akash", "3");
        if (this.state.linkData && this.state.linkData.columnkeyMap) {
            let columnkeyMap = { ...this.state.linkData.columnkeyMap };
            let columnlist = Object.keys(columnkeyMap).map(function (key) {
                var keyMap = columnkeyMap[key] === "Estado" ? "estado" : "checkbox";
                return { field: columnkeyMap[key], columnMenuType : keyMap};
            });
            console.log("columnlist -> ", columnlist)
            let actionbuttons = this.state.linkData.actionbuttons;
            // console.log("actionbuttons", actionbuttons);
             console.log("filterData", this.state.filterData);

            let telkikTable = (
                <TlkTable
                    date={new Date()}
                    list={this.state.filterData}
                    modulename={this.state.linkData.modulename || "fordefault"}
                    columnlist={columnlist}
                    actionbuttons={false}
                    ActionPerform={false}
                    groupfield={this.state.linkData.groupfield}
                    collepsview={this.state.linkData.collepsview}
                    viewFor={this.state.linkData.viewFor}
                />
            );
            this.setState({
                telkikTable: telkikTable,
            });
        }
    }

    /* Obter filtros aplicados na tabela para atualização dinâmica */
    tableFilters = (tlfilter) => {
        // console.log("tlfilter",tlfilter);
        try{
            let tlkState = { ...tlfilter };
            let linkData = { ...this.state.linkData };
         
            // linkData.Filters = data.Filters
            this.setState({
                tlkState,
                linkData
            }, () => this.getListData());
        }catch(error){
            this.setState({error : error})
        }
        // return data;
    }

    /* Alterações de filtro de tabela em formatos de API */
    makeTlkFilters = (tlkfilter, columnkeyMap, data) => {
        let inFilters = {};
        let columnkeyMaprev = {};
        // console.log("-----------pppppppppp",columnkeyMap)
        for (var key in columnkeyMap) {
            columnkeyMaprev[columnkeyMap[key]] = key;
        }
        if (tlkfilter.filter && tlkfilter.filter.filters && tlkfilter.filter.filters.length > 0) {
            let tkkey = "";
            let tkkeyvalues = [];
            tlkfilter.filter.filters.map((_row, i) => {
                tkkey = "";
                tkkeyvalues = [];
                let checkamount = [];
                if (_row.filters && _row.filters.length > 0) {
                    _row.filters.map((_srow, k) => {
                        tkkey = _srow.field;
                        _srow.value=_srow.value ?_srow.value : ""
                        checkamount =  _srow.value.split(" ")
                        if (checkamount[1] && checkamount[1] === "€") {
                            checkamount[0] = checkamount[0].replace(".", "");
                            checkamount[0] = checkamount[0].replace(",", ".");
                            _srow.value = checkamount[0];
                        }
                        _srow.value = $.isNumeric(_srow.value) ? Number(_srow.value) : _srow.value;
                        tkkeyvalues.push(_srow.value)
                    })
                    tkkey = columnkeyMaprev[tkkey];
                    tkkey = tkkey.toLowerCase();
                    inFilters[tkkey] = tkkeyvalues;
                }
            })
        }
        let defaultRequest = listdefaultRequest;
        defaultRequest.Page = tlkfilter.skip ? (tlkfilter.skip / tlkfilter.take + 1) : 1;
        defaultRequest.PageSize = tlkfilter.take ? tlkfilter.take : 100;
        if (tlkfilter && tlkfilter.sort && tlkfilter.sort.length > 0) {
            defaultRequest.SortBy = columnkeyMaprev[tlkfilter.sort[0].field];
            defaultRequest.IsSortTypeDESC = (tlkfilter.sort[0].dir === "asc") ? false : true;
        }
        // data.inFilters = inFilters;
        return data;
    }

    /*  Para realizar a ação com base na seleção da tabela  */

    ActionPerform = (action, row) => {
        if (this.props.ActionPerform) {
            this.props.ActionPerform(action, row)
        } else {
        }
    }

    /*  Para renderizar o conteúdo html da página   */

    render() {
        if(this.state.error){
            throw this.state.error;
        }
        return (
            <div className="custom-k-grid table-section">
                <div className="table-responsive">
                {
                    this.state.telkikTable &&
                    <>
                        <h3>{tablesjson[this.props.tableName] && tablesjson[this.props.tableName].totalPageHeading ? tablesjson[this.props.tableName].totalPageHeading + "("+this.state.totalcount+")" :`A pesquisa retornou ${this.state.totalcount} registos`}</h3>
                        {
                            this.state.telkikTable
                        }
                    </>
                }
                {
                  (this.state.totalcount === 0) &&
                  <div className="searct-found">
                    <img className="img-fluid" src="imgs/search-large-icon.png" alt="" />
                    {
                      this.state.showSearchMsg ? <p className="font-14">Sem resultados</p> : <h3>Pesquise uma instalação ou entidade para apresentação de mais informações</h3>
                    }
                  </div>
                }

                </div>
            </div>
        );
    }
}

export default SelosTables;